import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

if (process.env.NODE_ENV === 'production') {
    Raven.config('https://8166e7a949944866b6d83e54642e1a58@sentry.qda.io/4')
        .addPlugin(RavenVue, Vue)
        .install();
}
